import React, {useState, useEffect} from 'react';
import {Alert, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom'
import axios from 'axios';
import {apiUrl} from '../util/Api';
import {clearAuthentication} from '../util/Auth';

import {useDispatch} from 'react-redux';
import {clearUserStore} from '../app/slices/UserSlice';

const Logout = () => {
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    axios.get(apiUrl + '/logout', {withCredentials: true})
    .then((res) => {
      //console.log('logout results:', res.data)
      if(res.data.status === 'ok') {
        //console.log('logout success');
        clearAuthentication();
        dispatch(clearUserStore());
        setSuccess('You have successfully logged out')
      }
      else {
        //console.log('an error occurred');
        setErrors(['There was an error logging out.']);
      }
    })
    .catch((err) => {
      //error logging out?
      //console.log('a server error occurred');
      setErrors(['An error occured logging out.']);
    });
  },[dispatch]);



  return (
    <Col xs={10} sm={8} md={6} className="public-component">
      <h3>Logout</h3>
    {
      errors.length > 0 ? (
        <Alert variant='danger'>
        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
        </Alert>
      ) : (null)
    }
    {
      success !== '' ? (
        <Alert variant='primary'>
          {success}
        </Alert>
      ) : null
    }
      <div>
        <Link to="/login">Login</Link>
      </div>
    </Col>
  );
};

export default Logout;
